import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  DialogContentText,
} from "@mui/material";
import { Warning } from "@mui/icons-material";

interface UnsavedChangesDialogProps {
  open: boolean;
  onClose: () => void;
  onDiscard: () => void;
}

const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  open,
  onClose,
  onDiscard,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="unsaved-changes-dialog-title"
      aria-describedby="unsaved-changes-dialog-description"
    >
      <DialogTitle id="unsaved-changes-dialog-title">
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Warning color="warning" sx={{ mr: 1 }} />
          Unsaved Changes
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="unsaved-changes-dialog-description">
          You have unsaved changes. If you leave this page, your changes will be
          lost.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Stay on Page
        </Button>
        <Button onClick={onDiscard} color="error">
          Discard Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
